// Nespresso curated offers configuration

export interface NespressoOffer {
  id: string;
  name: string;
  description: string;
  originalPrice: number;
  discountPercent: number;
  image: string;
  tag?: string;
}

export const NESPRESSO_OFFERS: NespressoOffer[] = [
  {
    id: 'nespresso-best-sellers',
    name: 'Classic Best Sellers',
    description: '50 capsules of our most popular Original Line blends',
    originalPrice: 45.00,
    discountPercent: 20,
    image: '/assets/images/products/nespresso-classic-best-sellers/main.png',
    tag: 'Best Value',
  },
  {
    id: 'nespresso-vertuo-set',
    name: 'Vertuo Discovery Set',
    description: '30 Vertuo capsules with exclusive accessories',
    originalPrice: 59.00,
    discountPercent: 15,
    image: '/assets/images/products/nespresso-vertuo-gift-set/main.png',
    tag: 'Recommended',
  },
  {
    id: 'nespresso-aeroccino',
    name: 'Aeroccino 4',
    description: 'Premium milk frother with 4 settings',
    originalPrice: 99.00,
    discountPercent: 25,
    image: '/assets/images/products/nespresso-aeroccino/main.png',
    tag: 'Accessory',
  },
];

export const getDiscountedPrice = (offer: NespressoOffer): number => {
  return offer.originalPrice * (1 - offer.discountPercent / 100);
};
